import { set } from "lodash";

const getPath = (filePath) =>
    filePath
        .substr(2)
        .split("/")
        .reduce((carry, pathPart, index, all) => {
            if (index < all.length - 1) return `${carry}.${pathPart}`;
            else return `${carry}.${pathPart.split(".").shift()}`;
        }, "")
        .substr(1);

const requireContext = require.context("./", true, /\.json$/);
const json = requireContext
    .keys()
    .filter((key) => key.includes("./"))
    .reduce((carry, key) => {
        const obj = requireContext(key);
        const path = getPath(key);
        return set(carry, path, obj);
    }, {});

export default json;
